import styled from 'styled-components';

export const Layout = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 100px;
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 130px;
  justify-content: space-between;
  max-width: 1200px;
`;

export const TextsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.km6};
  max-width: 480px;
`;

export const QRCodeWrapper = styled.div`
  border: 1px solid #babec9;
  border-radius: 16px;
  padding: ${({ theme }) => theme.spacing.km8};
`;

export const List = styled.ul`
  list-style: none;

  li {
    margin-bottom: ${({ theme }) => theme.spacing.km6};

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const ListItem = styled.li`
  display: flex;
  gap: 16px;
`;
